import * as React from 'react'
import { useTranslation } from '@pancakeswap/localization'
import { WalletModalV2 } from '@pancakeswap/ui-wallets'
import { createWallets, getDocLink } from 'config/wallet'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useAuth from 'hooks/useAuth'
import { useActiveHandle } from 'hooks/useEagerConnect.bmp'
import { useMemo, useState } from 'react'
import { useConnect, useWalletClient } from 'wagmi'
import { cloneElement } from '../../_util/reactNode'
import { Button } from '../../index'
import Trans from '../../../components/Trans'
import classNames from '../../_util/classNames'

interface TargetProps {
  className?: string
  control?: boolean
  children?: React.ReactNode
}

const ContainerAuth: React.FC<TargetProps> = (props: TargetProps) => {
  const { className, control = true, children } = props

  const classes = classNames(className)

  const { data: walletClient } = useWalletClient()

  const handleActive = useActiveHandle()
  const { login } = useAuth()
  const {
    t,
    currentLanguage: { code },
  } = useTranslation()
  const { connectAsync } = useConnect()
  const { chainId } = useActiveChainId()
  const [open, setOpen] = useState(false)

  const docLink = useMemo(() => getDocLink(code), [code])

  const handleClick = () => {
    if (typeof __NEZHA_BRIDGE__ !== 'undefined') {
      handleActive()
    } else {
      setOpen(true)
    }
  }

  const wallets = useMemo(() => createWallets(chainId, connectAsync), [chainId, connectAsync])

  React.useEffect(() => {
    if (!walletClient) return
    setOpen(false)
  }, [walletClient])

  return (
    <>
      {control && !walletClient && (
        <Button onClick={handleClick} {...props}>
          <Trans>Connect Wallet</Trans>
        </Button>
      )}
      {walletClient && children && cloneElement(children, { className: classes })}
      <WalletModalV2
        docText={t('Learn How to Connect')}
        docLink={docLink}
        isOpen={open}
        wallets={wallets}
        login={login}
        onDismiss={() => setOpen(false)}
      />
    </>
  )
}

export default React.memo(ContainerAuth)
